export enum AdminNotificationCategory {
  Order = 0,
  Customer = 1,
  Support = 2,
  Product = 3
};
